import { Vue } from "vue-property-decorator"
import { commonObjectState } from "~/state/object"
import { IObjectState } from "~/state/types"
import { NewRequester } from "~/core/Requester"
import ObjectHelper from "~/utils/ObjectHelper"
import { RichMenuListState } from "./models/richmenu"
import { IOAInfoState } from "./models/oa_info"

interface CreatedReichMenu {
  richMenuId: string
}
interface ILineOfficialState {
  oaInfo: IObjectState<IOAInfoState | null>
  richmenuList: IObjectState<RichMenuListState | null>
  createdRichmenu: IObjectState<CreatedReichMenu | null>
  richmenuItem: IObjectState<any>
  richmenuInsightSummary: IObjectState<any>
  richmenuInsightDaily: IObjectState<any>
  deletedRichmenu: IObjectState<any>
}

export const prefix = "line/line"

export const state = (): ILineOfficialState => ({
  oaInfo: commonObjectState<IOAInfoState>(),
  richmenuList: commonObjectState<RichMenuListState>(),
  createdRichmenu: commonObjectState<CreatedReichMenu>(),
  richmenuItem: commonObjectState<any>(),
  richmenuInsightSummary: commonObjectState<any>(),
  richmenuInsightDaily: commonObjectState<any>(),
  deletedRichmenu: commonObjectState<any>(),
})

export const getters = {
  oaInfo: (state: ILineOfficialState) => () => {
    return state.oaInfo
  },
  richmenuList: (state: ILineOfficialState) => () => {
    return state.richmenuList
  },
  createdRichmenu: (state: ILineOfficialState) => () => {
    return state.createdRichmenu
  },
  richmenuItem: (state: ILineOfficialState) => () => {
    return state.richmenuItem
  },
  richmenuInsightSummary: (state: ILineOfficialState) => () => {
    return state.richmenuInsightSummary
  },
  richmenuInsightDaily: (state: ILineOfficialState) => () => {
    return state.richmenuInsightDaily
  },
  deletedRichmenu: (state: ILineOfficialState) => () => {
    return state.deletedRichmenu
  },
}

export const mutations = {
  updateOAInfo: (state: IOAInfoState, data) => {
    Vue.set(state, "oaInfo", data)
  },
  updateRichmenuList: (state: IOAInfoState, data) => {
    Vue.set(state, "richmenuList", data)
  },
  clearOAInfo: (state: IOAInfoState) => {
    Vue.set(state, "oaInfo", commonObjectState())
  },
  updateCreatedRichmenu: (state: IOAInfoState, data) => {
    Vue.set(state, "createdRichmenu", data)
  },
  updateRichmenuItem: (state: IOAInfoState, data) => {
    Vue.set(state, "richmenuItem", data)
  },
  updateRichmenuInsightSummary: (state: IOAInfoState, data) => {
    Vue.set(state, "richmenuInsightSummary", data)
  },
  updateRichmenuInsightDaily: (state: IOAInfoState, data) => {
    Vue.set(state, "richmenuInsightDaily", data)
  },
  updateDeletedRichmenu: (state: IOAInfoState, data) => {
    Vue.set(state, "deletedRichmenu", data)
  },
}

export const actions = {
  getRichmenuByID: async ({ commit, state }, data) => {
    try {
      const loadingState = ObjectHelper.toLoadingStatus(state.oaInfo)
      loadingState.data = undefined

      commit("updateRichmenuItem", loadingState)
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        "updateRichmenuItem",
        ObjectHelper.toObjSuccessStatus(state.oaInfo, response.data)
      )
    } catch (e: any) {
      const newState = ObjectHelper.toErrorStatus(
        state.oaInfo,
        e.response?.data || e
      )
      newState.data = undefined
      commit("updateRichmenuItem", newState)
    }
  },
  getRichmenuInsightSummary: async ({ commit, state }, data) => {
    try {
      const loadingState = ObjectHelper.toLoadingStatus(
        state.richmenuInsightSummary
      )
      loadingState.data = undefined

      commit("updateRichmenuInsightSummary", loadingState)
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        "updateRichmenuInsightSummary",
        ObjectHelper.toObjSuccessStatus(
          state.richmenuInsightSummary,
          response.data
        )
      )
    } catch (e: any) {
      const newState = ObjectHelper.toErrorStatus(
        state.richmenuInsightSummary,
        e.response?.data || e
      )
      newState.data = undefined
      commit("updateRichmenuInsightSummary", newState)
    }
  },
  getRichmenuInsightDaily: async ({ commit, state }, data) => {
    try {
      const loadingState = ObjectHelper.toLoadingStatus(
        state.richmenuInsightDaily
      )
      loadingState.data = undefined

      commit("updateRichmenuInsightDaily", loadingState)
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        "updateRichmenuInsightDaily",
        ObjectHelper.toObjSuccessStatus(state.richmenuInsightDaily, response.data)
      )
    } catch (e: any) {
      const newState = ObjectHelper.toErrorStatus(
        state.richmenuInsightDaily,
        e.response?.data || e
      )
      newState.data = undefined
      commit("updateRichmenuInsightDaily", newState)
    }
  },
  getOAInfo: async ({ commit, state }, data) => {
    try {
      const loadingState = ObjectHelper.toLoadingStatus(state.oaInfo)
      loadingState.data = undefined

      commit("updateOAInfo", loadingState)
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        "updateOAInfo",
        ObjectHelper.toObjSuccessStatus(state.oaInfo, response.data)
      )
    } catch (e: any) {
      const newState = ObjectHelper.toErrorStatus(
        state.oaInfo,
        e.response?.data || e
      )
      newState.data = undefined
      commit("updateOAInfo", newState)
    }
  },
  getRichmenuList: async ({ commit, state }, data) => {
    try {
      const loadingState = ObjectHelper.toLoadingStatus(state.richmenuList)
      loadingState.data = undefined

      commit("updateRichmenuList", loadingState)
      const response = await NewRequester.get<any>(data.url, { ...data })
      commit(
        "updateRichmenuList",
        ObjectHelper.toObjSuccessStatus(state.richmenuList, response.data)
      )
    } catch (e: any) {
      const newState = ObjectHelper.toErrorStatus(
        state.richmenuList,
        e.response?.data || e
      )
      newState.data = undefined
      commit("updateRichmenuList", newState)
    }
  },
  createRichMenu: async ({ commit, state }, data) => {
    try {
      const loadingState = ObjectHelper.toLoadingStatus(state.createdRichmenu)
      loadingState.data = undefined

      commit("updateCreatedRichmenu", loadingState)

      const response = await NewRequester.post<any>(
        data.options.url,
        {
          rich_menu_json: data.richMenuJSON,
          image_url: data.imageURL,
        },
        data.options
      )

      commit(
        "updateCreatedRichmenu",
        ObjectHelper.toObjSuccessStatus(state.createdRichmenu, response.data)
      )
    } catch (e: any) {
      const newState = ObjectHelper.toErrorStatus(
        state.createdRichmenu,
        e.response?.data || e
      )
      newState.data = undefined
      commit("updateCreatedRichmenu", newState)
    }
  },
  deleteRichMenu: async ({ commit, state }, data) => {
    try {
      const loadingState = ObjectHelper.toLoadingStatus(state.deletedRichmenu)
      loadingState.data = undefined

      commit("updateDeletedRichmenu", loadingState)

      const response = await NewRequester.delete<any>(data.url, { ...data })

      commit(
        "updateDeletedRichmenu",
        ObjectHelper.toObjSuccessStatus(state.deletedRichmenu, response.data)
      )
    } catch (e: any) {
      const newState = ObjectHelper.toErrorStatus(
        state.deletedRichmenu,
        e.response?.data || e
      )
      newState.data = undefined
      commit("updateDeletedRichmenu", newState)
    }
  },
}

export const namespaced = true
